export interface ISaveOpportunityDeadline {
  type: string;
  deadline?: Date;
}

export class SaveOpportunityDeadline {
  public type: string;
  public deadline?: Date;

  constructor(data: { type: string, deadline?: Date }) {
    this.type = data.type;
    this.deadline = data.deadline;
  }
}
